/* eslint-disable jsx-a11y/anchor-is-valid */
// eslint-disable-next-line
import React, { useState } from "react";
import PopUpModal from "./PopUpModal"



const PopUpLink = ({ to = "", page_format, file_type, children }) => {
  const [isPopUpVisible, setIsPopUpVisible] = useState(false);

  const OpenPopupLink = () => {
    setIsPopUpVisible(true);
  }

  const onCancel = () => {
    setIsPopUpVisible(false);
  };

  return (
    /*eslint no-script-url: "off"*/
    <>
      <a href="javascript:void(0)" onClick={OpenPopupLink} rel="noopener noreferrer">
        {children}
      </a >

      <PopUpModal
        visible={isPopUpVisible}
        onCancel={onCancel}
        link={to}
        page_format={page_format}
        file_type={file_type}
      />
    </>
  )
}

export default PopUpLink